<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  submittedAt?: string | null
  completedAt?: string | null
  reprovedAt?: string | null
  orderChangedAt?: string | null
}>()

const { t, d } = useI18n()

function parseValidDate(value: string | null | undefined): string | null {
  if (typeof value !== 'string' || !value.trim())
    return null

  const timestamp = Date.parse(value)
  return Number.isNaN(timestamp) ? null : value
}

const validOrderChangedAt = computed(() => parseValidDate(props.orderChangedAt))
</script>

<template>
  <div class="flex gap-8 items-start whitespace-nowrap">
    <div class="flex flex-col gap-0.5 w-[100px]">
      <span class="fonts-body-small-regular text-brand-primary-medium">{{ t('accordion.date.submittedAt') }}</span>
      <span class="text-[13px] font-bold text-neutral-low-dark">{{ submittedAt ? d(submittedAt, 'short') : '—' }}</span>
    </div>

    <div v-if="!reprovedAt" class="flex flex-col gap-0.5 w-[100px]">
      <span class="fonts-body-small-regular text-brand-primary-medium">{{ t('accordion.date.completedAt') }}</span>
      <span class="text-[13px] font-bold text-neutral-low-dark">{{ completedAt ? d(completedAt, 'short') : '—' }}</span>
    </div>

    <div v-if="reprovedAt" class="flex flex-col gap-0.5 w-[100px]">
      <span class="fonts-body-small-regular text-brand-primary-medium">{{ t('accordion.date.reprovedAt') }}</span>
      <span class="text-[13px] font-bold text-neutral-low-dark">{{ d(reprovedAt, 'short') }}</span>
    </div>

    <div v-if="validOrderChangedAt" class="flex flex-col gap-0.5 w-[100px]">
      <span class="fonts-body-small-regular text-brand-primary-medium">{{ t('accordion.date.orderChangedAt') }}</span>
      <span class="text-[13px] font-bold text-neutral-low-dark">{{ d(validOrderChangedAt, 'short') }}</span>
    </div>
  </div>
</template>
